<div class="chatbot-container" [class.open]="isOpen">
  <div class="chatbot-header" (click)="toggleChat()">
    PRISMPdM Assistant
  </div>
  <div class="chatbot-body">
    <div id="webchat" style="height: 400px; width: 300px;"></div>
  </div>
</div>

<!-- Floating toggle button (optional) -->
<button class="chatbot-toggle" (click)="toggleChat()">💬</button>

